import client from '@/api/client';
import { BASE_URL } from '@/constants';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
export default {
	//변수값 가져오기
	getVariableValue: (varId, strtDt) => {
		if (!varId) return false;
		if(!strtDt) strtDt = '';
		return client
			.get(`${BASE_URL}/comm/common/comVar/v1/var?varId=${varId}&strtDt=${strtDt}`)
			.then(response => {
				return response?.data.body.resultList;
			})
			.catch(error => {
				throw error.response.data;
			});
	},
	getPartner: () => {
		//협력사 여부 및 협력사 정보 가져오기
		const IN_GRP = 'inGrp';
		return client
			.get(`${BASE_URL}/comm/common/comCpny/v1/cpny?varId=${IN_GRP}`)
			.then(response => {
				return response?.data?.body?.resultList || response;
			})
			.catch(error => {
				throw error?.response?.data || error;
			});
	},
	addExcelUpload: ({ formData }) => {
		//엑셀업로드
		const url = `${BASE_URL}/comm/common/excel/v1/status/1/commExcelUpload`;
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw new Error(error.response.data);
			});
	},
	async deleteFile({ fileId, fileSeq }) {
		//첨부파일 삭제
		try {
			const queryStr = !!fileSeq ? `?fileSeq=${fileSeq}` : '';
			const response = await client.get(`${BASE_URL}/comm/common/qmsFileInfo/v1/status/3/fileId/${fileId}${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getDeptNm: deptCd => {
		//부서 이름 조회
		if (!deptCd) return false;
		return client
			.get(`${BASE_URL}/comm/common/comDeptInfo/v1/deptNm?deptCd=${deptCd}`)
			.then(response => {
				return response?.data.body.result;
			})
			.catch(error => {
				throw error.response.data;
			});
	},
	getUsrGrpInfo() {
		//사용자 그룹정보 조회
		return client
			.get(`${BASE_URL}/comm/common/usrGrpInfo/v1/user`)
			.then(response => {
				return response?.data.body.resultList;
			})
			.catch(error => {
				throw error.response.data;
			});
	}
};
